<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>
      {{
        (isEditing ? 'global-settings.configure-system-groups.domain-management.edit.edit-an-entity-domain' : 'global-settings.configure-system-groups.domain-management.add-entity-domain')
          | translate
      }}
    </h4>
  </ng-template>

  <form #editForm="ngForm" class="atlas-form" [wl-busy-overlay]="loadingEntityDomain" [busyCenter]="true">
    <div class="mct-flex mct-col mct-gap-27" *ngIf="entityDomain"  >
      <div>
        <label class="light-text">{{ 'global-settings.configure-system-groups.domain-management.domain' | translate | ucfirst }}</label>
        <input [(ngModel)]="entityDomain.Domain" name="domain" />
      </div>
      <div>
        <label class="light-text">{{ 'global-settings.configure-system-groups.domain-management.edit.domain-type' | translate | ucfirst }}</label>
        <p-select
          name="domainType"
          appendTo="body"
          [(ngModel)]="entityDomain.DomainTypeID"
          [options]="domainRoots"
          [style]="{ width: '100%' }"
          required
        ></p-select>
      </div>
      <div *ngIf="entityDomain.DomainTypeID == 2">
        <label class="light-text">{{ 'global-settings.configure-system-groups.domain-management.edit.redirect-to-domain' | translate | ucfirst }}</label>
        <input [(ngModel)]="entityDomain.RedirectToDomain" name="redirectToDomain" />
      </div>
      <div *ngIf="entityDomain.DomainTypeID == 1">
        <label class="light-text">{{ 'global-settings.configure-system-groups.domain-management.edit.path-to-virtual-root' | translate | ucfirst }}</label>
        <input [(ngModel)]="entityDomain.PathFromRootToEntityPagesFolder" name="pathFromRootToEntityPagesFolder" />
      </div>
      <div>
        <label class="light-text">{{ 'global-settings.configure-system-groups.domain-management.edit.domain-type' | translate | ucfirst }}</label>
        <p-select
          name="entityId"
          appendTo="body"
          [(ngModel)]="entityDomain.EntityID"
          [options]="entityAffCodes"
          [style]="{ width: '100%' }"
          [placeholder]="'global-settings.configure-system-groups.domain-management.edit.select-entity' | translate | titlecase"
        ></p-select>
      </div>
      <div>
        <label class="light-text">{{ 'global-settings.configure-system-groups.domain-management.edit.setting-batch' | translate | ucfirst }}</label>
        <input [(ngModel)]="entityDomain.SettingBatch" name="settingBatch" />
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" [disabled]="isSaving" (click)="close()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!editForm.valid" (click)="save()">
        <wl-busy [show]="isSaving"></wl-busy>
        <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
